import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swiper from 'swiper';
import { ProductsService } from '../../../../core/services/products.service';

interface DemoItem {
  name: string;
  description: string;
  image: string;
  url: string;
}

@Component({
  selector: 'app-demos',
  templateUrl: './demos.component.html',
  styleUrls: ['./demos.component.scss'],
})
export class DemosComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('cardsContainer', { static: true }) cardsContainer!: ElementRef;
  demoItems!: DemoItem[];
  loadingDemos: boolean = true;
  skeletonArray = Array(3);

  private boundApplyOverlayMask!: (e: PointerEvent) => void;
  private swiperInstance?: Swiper;
  private swiperElement?: HTMLElement;
  private isMobile = false;

  constructor(
    private translate: TranslateService,
    private productsService: ProductsService
  ) {
    this.productsService.getProductsData().subscribe((products) => {
      if (products[products.length - 1]) {
        this.demoItems = products[products.length - 1].demos
          .filter((demo: any) => demo.name !== 'Défaut')
          .map((demo: any) => {
            if (demo.description && demo.description !== '') {
              demo.description = this.translate.instant(demo.description);
            }
            return demo;
          });
    
        this.loadingDemos = false;
      }
    });
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth < 1200;
    if (this.isMobile) {
      this.waitSlide();
    }
  }

  private waitSlide(): void {
    this.swiperElement = this.cardsContainer.nativeElement.querySelector('.swiper-container') as HTMLElement;
  
    const x = setInterval(() => {
      if (this.swiperElement) {
        const slides = this.swiperElement.querySelectorAll('.swiper-slide');
        if (slides.length > 0) {
          clearInterval(x);
          this.initialiseSwiper();
        }
      } else {
        clearInterval(x); // Stop l'intervalle si l'élément ne peut pas être trouvé
      }
    }, 100);
  }

  private initialiseSwiper(): void {
    if (
      this.swiperElement &&
      (!this.swiperInstance || this.swiperInstance.destroyed)
    ) {
      var self = this;
      this.swiperInstance = new Swiper(this.swiperElement, {
        rewind: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          resize() {
            self.swiperInstance?.update();
          },
        },
      });
    }
  }

  ngOnDestroy(): void {
    document.body.removeEventListener(
      'pointermove',
      this.boundApplyOverlayMask
    );
    if (this.swiperInstance && !this.swiperInstance.destroyed) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = undefined;
      this.swiperElement = undefined;
    }
  }

  ngAfterViewInit(): void {
    this.isMobile = window.innerWidth < 1200;
    this.boundApplyOverlayMask = this.applyOverlayMask.bind(this);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isMobile) {
            document.body.addEventListener(
              'pointermove',
              this.boundApplyOverlayMask
            );
          } else {
            document.body.removeEventListener(
              'pointermove',
              this.boundApplyOverlayMask
            );
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.cardsContainer.nativeElement);
  }

  applyOverlayMask(e: PointerEvent) {
    if (!this.cardsContainer) return;
    const cardsContainer = this.cardsContainer.nativeElement as HTMLElement;
    const overlay = this.cardsContainer.nativeElement.querySelector(
      '.overlay'
    ) as HTMLElement;

    if (!cardsContainer || !overlay) return;

    const x = e.pageX - cardsContainer.offsetLeft;
    const y = e.pageY - cardsContainer.offsetTop;
    overlay.style.setProperty('--opacity', '1');
    overlay.style.setProperty('--x', `${x}px`);
    overlay.style.setProperty('--y', `${y}px`);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isMobile = window.innerWidth < 1200;
    if (
      !this.isMobile &&
      this.swiperInstance &&
      !this.swiperInstance.destroyed
    ) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = undefined;
      this.swiperElement = undefined;
    } else if (this.isMobile && !this.swiperInstance) {
      this.waitSlide();
    }
  }
}
